import { useGlobalContentStore } from '~/store/globalContent';

export default defineNuxtRouteMiddleware((to) => {
  if (to.path === '/') {
    const globalContentStore = useGlobalContentStore();

    // Corporate sites redirect to their own pah from domain-mapper
    if (globalContentStore.getIsNonEcomSite) {
      const basePath = globalContentStore.getStoryblokBasePath;
      return navigateTo(`/${basePath}`);
    }

    // Default: redirect to /uk
    return navigateTo('/uk');
  }
});
